import {
    GET_FAQS,
    DELETE_FAQ,
    CREATE_FAQ,
    UPDATE_FAQ
    
} from '../../_actions/types';

const initState = {
    error: null,
    faqs:  [], 
    faq : {},
}; 

export default function faq(state = initState, action){
    switch (action.type) {
        case GET_FAQS :
            return{
            ...state, 
            faqs: action.payload,
                
        }
        case CREATE_FAQ :
            return {
                ...state,
                faqs: [action.payload, ...state.faqs]

            } 

        case DELETE_FAQ :
            return{ 
                ...state,
                faqs: state.faqs.filter(faq => faq.id !== action.payload)
            }
            
        case UPDATE_FAQ:
          return {
            ...state,
            faqs : state.faqs.map(faq => faq.id === action.payload.id ? (faq = action.payload) : faq )
            
          }
         
        default : {
            return state
        }
    }
}
